'use client';

import Image from 'next/image';
import { Box } from '@mui/material';
import { halo, reducedMotion } from '@/app/inbox/motion';

/** Timmy's mark wherever Timmy appears: the round icon on an ink disc. `active` pulses a halo while Timmy works. */
export function TimmyMark({ size = 20, active = false }: { size?: number; active?: boolean }) {
  return (
    <Box
      component="span"
      sx={{
        position: 'relative',
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        bgcolor: 'var(--ink)',
        boxShadow: '0 0 0 1px rgba(20,20,18,0.08)',
        ...(active && { animation: `${halo} 1.4s ease-out infinite`, overflow: 'visible', ...reducedMotion }),
      }}
    >
      <Image src="/timmy-icon.png" alt="" width={size} height={size} draggable={false} style={{ display: 'block', borderRadius: '50%', objectFit: 'cover', userSelect: 'none' }} />
    </Box>
  );
}
